import { SignupModeEnum } from '@mentimeter/http-clients';

export const SSO_SIGNUPMODES = [
  SignupModeEnum.SOFT_SSO,
  SignupModeEnum.STRICT_SSO,
  SignupModeEnum.SSO,
];
